export default __webpack_public_path__ + "static/media/p9.3583652c.jpeg";